import { AfterViewInit, Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'gl-cart-end-warning-modal-v2',
    templateUrl: './cart-end-warning-modal-v2.component.html'
})
export class CartEndWarningModalV2Component implements AfterViewInit {
    @ViewChild('focus') focus: ElementRef;
    @Output() closeModal = new EventEmitter<void>();
    @Output() goToCartEvent = new EventEmitter<void>();

    ngAfterViewInit() {
        setTimeout(() => this.focus.nativeElement.focus());
    }

    goToCart() {
        this.goToCartEvent.emit();
    }

    closeDialog() {
        this.closeModal.emit();
    }
}
